/**
 * SA-1183 (spec §5, §6.3): the pricing view's server sort keys, each column's id under the
 * `compass.` namespace with its first click. The server registers the same keys through the
 * module sort hook (`app/custom/compass/pricing/sorts.py`); both are pinned by
 * shared/compass-pricing-sort-keys.json, so move all three together. A viewer without
 * `orders:read:pricing` is never offered the view, and the server sorts by nothing for one.
 */
import type { SortDir } from '@/components/records/registerSort'

export const PRICING_SORTS = {
  'compass.block_hours': 'desc',
  'compass.target_price': 'desc',
  'compass.price_offered': 'desc',
  'compass.cost_estimated': 'desc',
  'compass.cost_actual': 'desc',
  'compass.target_rate': 'desc',
  'compass.margin_estimated': 'desc',
  'compass.margin_actual': 'desc',
  'compass.price_contracted': 'desc',
} as const satisfies Readonly<Record<string, SortDir>>

export type PricingSortKey = keyof typeof PRICING_SORTS
